import { createElement } from 'react';
import type { VFC } from 'react';

import classNames from 'classnames';

import * as styles from './Title.module.scss';

export interface TitleProps {
  title: string;
  className?: string;
  rootElement?: 'p' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const Title: VFC<TitleProps> = ({ title, className, rootElement = 'div' }) => {
  const titleClassName = classNames(styles.assetTitle, className);

  return createElement(rootElement, { className: titleClassName }, title);
};

export { Title };
